import React, {useState} from 'react';
import {Alert, Button, Flex, message, Modal} from "antd";
import {jwtDecode} from "jwt-decode";
import {GoogleLogin} from "@react-oauth/google";
import {JWTDecoded, LoginOutput} from "../types";
import {useTranslation} from "react-i18next";
import {useInAppBrowserDetector} from "./useInAppBrowserDetector";
import {GoogleOutlined} from "@ant-design/icons";
import {Heading} from "../../../commons/translations/Heading";

export interface LoginButtonProps {
    login: (jwt: string) => Promise<LoginOutput>,
    captureUser: (result: LoginOutput, jwt: JWTDecoded) => void,
    setWorking: (working: boolean) => void
}

export const LoginButton: React.FC<LoginButtonProps> = (props) => {
    const {
        login,
        captureUser,
        setWorking
    } = props;
    const {t} = useTranslation();
    const [isInAppBrowserWarningOpen, setIsInAppBrowserWarningOpen] = useState<boolean>(false);
    const { isInAppBrowser } = useInAppBrowserDetector();
    return (
        <>
            <Modal open={isInAppBrowserWarningOpen} closable={false} footer={null}>
                <Flex justify={'center'} align={'center'}>
                    <Heading level={4} trl={'auth.in.app.browser.title'} />
                </Flex>
                <Alert
                    description={t('auth.in.app.browser')}
                    type="warning"
                    showIcon
                />
                <Alert
                    style={{marginTop: 8}}
                    type={"info"}
                    description={t('auth.in.app.browser.instead')}
                    showIcon={true}
                />
                <p style={{ marginTop: 8 }}>
                    <Button type={"default"} style={{width: '100%'}} onClick={() => setIsInAppBrowserWarningOpen(false)}>{t('common.ok')}</Button>
                </p>
            </Modal>
            {!isInAppBrowser && (
                <GoogleLogin onSuccess={(s) => {
                    if (!s.credential) {
                        message.error(t('auth.failure')).then()
                        return;
                    }
                    const jwt = s.credential;
                    login(jwt).then(result => {
                        captureUser(result, jwtDecode(jwt));
                    });
                }} onError={() => {
                    message.error(t('auth.failure')).then(() => {
                        setWorking(false);
                    })
                }}
                             use_fedcm_for_button={true}
                             use_fedcm_for_prompt={true}
                />
            )}
            {isInAppBrowser && (
                <p>
                    <Button size={"middle"} style={{width: '100%'}} icon={<GoogleOutlined />} onClick={() => {
                        setIsInAppBrowserWarningOpen(true);
                    }} >{t('login.google')}</Button>
                </p>
            )}
        </>
    );
};